import React from 'react';
import { AppContainer } from 'containers/AppContainer';
import { AdminAppContainer } from 'containers/AdminAppContainer';

export const AppWrapper: React.FC<{ isAdminPortal: boolean }> = ({ isAdminPortal }) =>
  !isAdminPortal ? <AppContainer /> : <AdminAppContainer />;
